import { checkHttpStatus, parseJSON } from '../../utils/response';
import i18next from 'i18next';
import * as LoginCode from '../../scripts/StatusLoginCode';
import * as StatusCode from '../../scripts/StatusCode';
import jwt from 'jwt-decode';
import { getDefaultParam, getDefaultParamPE } from '../param';
import 'whatwg-fetch';
import * as storage from '../../utils/storage'
import { IsEnglish } from '../../utils/language';
import { encryptPassword } from '../../utils';
import { encryption } from '../../utils/encryption';
import { getIP } from '../../utils/index';
import { listMenu } from '../../actions/configMenu';
import { noMenuRedirect } from '../../utils/redirect';
import * as cookie from '../../scripts/CookiesAppGo';

export function renewTokenSuccess(token) {
    storage.saveToken(token);

    const userData = jwt(token);
    storage.saveSessionGuid(userData.SessionGuid);
}


export function loginUserSuccess(token, acceptedTermsUse, termsUse, legalInfo, showDateStatementTerms,
    showDateStatementLegalInfo, scheduleReturnDate, useGeolocation, useGeolocationZone, creditCardSupport,
    punchTime, colorCalendar, useWorkInstructions, isDisplayMedicalData, isDisplayDistributionSlip,
    isDisplayPreferenceCommunication, isCCQ, isPartialRequestHoursUsed, taxationProvince,
    isMandatoryPhoneCellPerso, isMandatoryEmailPerso, isMandatorySMSPerso, communicationPreference, userName,
    isDisplayPayAdvanceVacation, isUsePartialRequest, isDisplayPayablesHours, isUseMaterialResourceTimesheet,
    notificationPublicKey, isNotificationActivate, isDisplayFlagFullTime, isProfileConsultationMode, isDisplayBankOthers,
    isDisplayBankVacation, useServiceProvider, useGeolocationMandatory) {
    storage.saveToken(token);
    storage.saveAcceptedTermsUse(acceptedTermsUse);
    storage.saveTermsUse(termsUse);
    storage.saveLegalInfo(legalInfo);
    storage.saveShowDateStatementTerms(showDateStatementTerms);
    storage.saveShowDateStatementLegalInfo(showDateStatementLegalInfo);
    storage.saveScheduleReturnDate(scheduleReturnDate);
    storage.saveUseGeolocation(useGeolocation);
    storage.saveUseGeolocationZone(useGeolocationZone);
    storage.saveCreditCardSupport(creditCardSupport);
    storage.savePunchTime(punchTime);
    storage.saveColorCalendar(colorCalendar);
    storage.saveUseWorkInstructions(useWorkInstructions);
    storage.saveDisplayMedicalData(isDisplayMedicalData);
    storage.saveDisplayDistributionSlip(isDisplayDistributionSlip);
    storage.saveDisplayPreferenceCommunication(isDisplayPreferenceCommunication);
    storage.saveIsCCQ(isCCQ);
    storage.savePartialRequestHoursUsed(isPartialRequestHoursUsed);
    storage.saveTaxationProvince(taxationProvince);
    storage.saveIsMandatoryPhoneCellPerso(isMandatoryPhoneCellPerso);
    storage.saveIsMandatoryEmailPerso(isMandatoryEmailPerso);
    storage.saveIsMandatorySMSPerso(isMandatorySMSPerso);
    storage.saveCommunicationPreference(communicationPreference);
    storage.saveUserName(userName);
    storage.saveIsDisplayPayAdvanceVacation(isDisplayPayAdvanceVacation);
    storage.saveIsUsePartialRequest(isUsePartialRequest);
    storage.saveIsDisplayPayablesHours(isDisplayPayablesHours);
    storage.saveIsUseMaterialResourceTimesheet(isUseMaterialResourceTimesheet);
    storage.saveNotificationPublicKey(notificationPublicKey);
    storage.saveDisplayFlagFullTime(isDisplayFlagFullTime);
    storage.saveIsProfileConsultationMode(isProfileConsultationMode);
    storage.saveIsDisplayBankOthers(isDisplayBankOthers);
    storage.saveIsDisplayBankVacation(isDisplayBankVacation);
    storage.saveUseServiceProvider(useServiceProvider);
    storage.saveUseGeolocationMandatory(useGeolocationMandatory);

    const userData = jwt(token);
    storage.saveSessionGuid(userData.SessionGuid);

    getDefaultParam().then((response) => {
        if (typeof response == 'undefined') return;

        const paramData = JSON.parse(response.list);

        if (paramData !== undefined) {
            storage.saveGoogleApiKey(paramData.mapsApiKey);
            storage.saveStartDayTimesheet(paramData.startDayTimesheet);
            storage.saveAbcUsage(paramData.useABC);
            storage.saveLinkProjectPActivity(paramData.linkProjectPActivity);
        }
    });

    getDefaultParamPE().then((response) => {
        if (typeof response == 'undefined') return;

        const paramData = JSON.parse(response.list);
        if (paramData !== undefined) {
            storage.saveUseTimeTimesheet(paramData.useTimeTimesheet);
            storage.saveUseTimeTimesheetRequired(paramData.useTimeTimesheetRequired);
        }
    });
}

export function loginFirstSetup(employeeId, userCode, isPasswordComplex, minLengthPassword, clientHashKey) {
    storage.saveEmployeeId(employeeId);
    storage.saveUserCode(userCode);
    storage.saveIsPasswordComplex(isPasswordComplex);
    storage.saveMinLengthPassword(minLengthPassword);
    storage.saveClientHashKey(clientHashKey);
}

export function loginUserFailure(error) {
    storage.destroyToken();
    storage.destroySessionGuid();
}

export function sessionLogout() {
    storage.destroyToken();
    storage.destroySessionGuid();
}

export function logoutAndRedirect() {
    sessionLogout();
}

export function loginUser(userCode, password, connection, isPrefixDB, redirect = "/") {
    password = encryptPassword(password);

    return fetch('authentication/login', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ UserCode: userCode, Password: password, Conn: connection, IsPrefixDB: isPrefixDB })
    })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            return handleLoginResponse(response);
        })
        .catch(error => {
            loginUserFailure(error);
        })
}

export async function loginUserSSO(userCode, connection) {
    const ip = await getIP();

    return fetch('authentication/loginSSO', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ userCode: encryption(userCode), ipAddress: ip, conn: connection })
    })
        .then(checkHttpStatus)
        .then(parseJSON)
        .then(response => {
            return handleLoginResponse(response);
        })
        .catch(error => {
            loginUserFailure(error);
        })
}

const handleLoginResponse = (response) => {
    try {
        const result = { statusLogin: -1, errorMessage: '', compagnies: [] };

        if (response.status === StatusCode.STATUS_UNAUTHORIZED) {
            result.statusLogin = LoginCode.LOGIN_FAILED;
            result.errorMessage = i18next.t('login:login.message.failed');
            return result;
        }

        let message = '';

        if (response.statusLogin === LoginCode.LOGIN_SUCCESSFULL) {
            // If the user has only one company so we save the data,
            // otherwise he will have to choose wich company he wants to access
            if (response.companies.length === 1) {
                // Save user data
                const dataCompany = response.companies[0];

                loginUserSuccess(response.token, response.isTermsValid,
                    IsEnglish() ? response.termsEn : response.termsFr,
                    IsEnglish() ? response.legalInfoEn : response.legalInfoFr,
                    response.showDateStatementTerms,
                    response.showDateStatementLegalInfo,
                    dataCompany.scheduleReturnDate,
                    dataCompany.useGeolocation,
                    dataCompany.useGeolocationZone,
                    dataCompany.creditCardSupport,
                    dataCompany.punchByTime,
                    dataCompany.colorCalendar,
                    dataCompany.useWorkInstructions,
                    dataCompany.isDisplayMedicalData,
                    dataCompany.isDisplayDistributionSlip,
                    dataCompany.isDisplayPreferenceCommunication,
                    dataCompany.isCCQ,
                    dataCompany.isPartialRequestHoursUsed,
                    dataCompany.taxationProvince,
                    dataCompany.isMandatoryPhoneCellPerso,
                    dataCompany.isMandatoryEmailPerso,
                    dataCompany.isMandatorySMSPerso,
                    dataCompany.communicationPreference,
                    response.userName,
                    dataCompany.isDisplayPayAdvanceVacation,
                    dataCompany.isUsePartialRequest,
                    dataCompany.isDisplayPayablesHours,
                    dataCompany.isUseMaterialResourceTimesheet,
                    response.notificationPublicKey,
                    response.isNotificationActivate,
                    dataCompany.isDisplayFlagFullTime,
                    dataCompany.isProfileConsultationMode,
                    dataCompany.isDisplayBankOthers,
                    dataCompany.isDisplayBankVacation,
                    dataCompany.useServiceProvider,
                    dataCompany.useGeolocationMandatory
                );
            } else {
                storage.saveToken(response.token);
                const userData = jwt(response.token);
                storage.saveSessionGuid(userData.SessionGuid);
                response.statusLogin = LoginCode.LOGIN_MULTIPLECOMPANIES
                result.companies = response.companies;
            }
            // Redirect Home

        } else if (response.statusLogin === LoginCode.LOGIN_USERLOCKED) {
            message = i18next.t('login:login.message.locked');
        } else if (response.statusLogin === LoginCode.LOGIN_PASSWORDFIRSTSETUP) {
            loginFirstSetup(response.employeeId, response.userCode, response.isPasswordComplex, response.minLengthPassword, response.clientHashKey);
            message = i18next.t('login:login.message.passwordFirstSetup');
        } else if (response.statusLogin === LoginCode.LOGIN_CHANGEPASSWORD) {
            message = i18next.t('login:login.message.changePassword');
        } else if (response.statusLogin === LoginCode.LOGIN_RESTRICTEDEMPLOYEEHIRED) {
            message = i18next.t('login:login.message.restrictedEmployeeHired');
        } else if (response.statusLogin === LoginCode.LOGIN_TEMPORARILYUNAVAILABLE) {
            message = i18next.t('login:login.message.temporarilyUnavailable');
        } else if (response.statusLogin === LoginCode.LOGIN_INACTIVEPORTAL) {
            message = i18next.t('login:login.message.inactivePortal');
        }

        result.statusLogin = response.statusLogin;
        result.errorMessage = message;

        return result;
    } catch (e) {
        loginUserFailure({
            response: {
                status: 403,
                statusText: 'Invalid token'
            }
        });
    }
}

export function connectApp(props, isAuthSSO = false) {
    // Load menu parameters and data
    listMenu().then(response => {
        if (response.status = StatusCode.STATUS_OK) {
            // Success
            storage.saveMenu(response.menu);
            storage.saveIsAuthSSO(isAuthSSO);

            saveCookieLogin(props);
            window.location.href = "";
        }
        else {
            storage.destroyMenu();
            noMenuRedirect();
        }
    });
}

const saveCookieLogin = (props) => {
    const { cookies } = props;
    // Here we save the datetime that the user login successfully
    cookies.set(cookie.login, new Date().toLocaleString(), { path: '/' });
}